import AuthorizationRouteComponent, {
  AuthorizationRouteComponentProps,
} from './AuthorizationRouteComponent';

export default AuthorizationRouteComponent;

export type { AuthorizationRouteComponentProps };
